import { makeAutoObservable } from "mobx";

export default class Group {
    _id;
    _name;
    _presentation;
    _youtube;
    constructor({ id, name, presentation, youtube }) {
        this._id = id;
        this._name = name;
        this._presentation = presentation;
        this._youtube = youtube;
        makeAutoObservable(this);
    }

    // GETTERS
    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    get presentation() {
        return this._presentation;
    }

    get youtube() {
        return this._youtube;
    }

    
    // SETTERS
    set id(id) {
        this._id = id;
    }

    set name(name) {
        this._name = name;
    }

    set youtube(youtube) {
        this._youtube = youtube;
    }

    set name(name) {
        this._name = name;
    }
}

